import TableHeader from "../Common/TableHeader";

function StudentRankings({studentRank}) {
    if (!studentRank || Object.keys(studentRank).length === 0) {
        return null;
    }

    const rankMap = [
        { label: "Booth Sessions", key: "sessions_rank" },
        { label: "Voice Calls", key: "voice_calls_rank" },
        { label: "Video Calls", key: "video_calls_rank" },
        { label: "Direct Calls", key: "direct_calls_rank" },
        { label: "Buzz Chats", key: "buzz_chats_rank" },
        { label: "Voice Notes", key: "voice_notes_rank" },
        { label: "Direct Messages", key: "dms_rank" },
        { label: "Buzztime Requests", key: "bts_rank" },
        { label: "Pocket Money Requests", key: "pms_rank" },
        { label: "Canteen Purchases", key: "canteen_rank" }
    ];

    // Filter only ranks that exist
    const visibleRanks = rankMap.filter(r => studentRank[r.key] !== undefined);

    if (visibleRanks.length === 0) {
        return null;
    }

    return (
        <>
            <TableHeader title="School Ranking" />

            <table className="table mb-0 mw-100 color-span">
                <tbody>
                    {visibleRanks.map((item) => (
                        <tr key={item.key}>
                            <td className="py-2 px-0">
                                <span className="w-50">{item.label}</span>
                            </td>
                            <td>:</td>
                            <td className="py-2 px-0">
                                <span>#{studentRank[item.key]}</span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}
export default StudentRankings;